// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable default-param-last */
import type { FareTypeState, RulesAction, FareTypeTicket, FareTypeRules } from "./services/types"
import {
  FARE_TYPES,
  GET_FARE_TYPE_RULES,
  GET_FARE_TYPE_RULES_FAILURE,
  GET_FARE_TYPE_RULES_REQUEST,
  GET_FARE_TYPE_RULES_SUCCESS,
} from "./services/consts"
import fetchFareTypeRules from "./services/api"
import type { BookingId } from "../../../../../../types/primitiveTypes"

const initialState: FareTypeState = {
  success: false,
  loading: false,
  error: false,
  ticket: FARE_TYPES.LEGACY,
  rules: {},
}

// REDUCER
export default function fareTypeReducer(
  state: FareTypeState | null | undefined = initialState,
  action: RulesAction,
) {
  switch (action.type) {
    // @ts-expect-error: Flow to TS migration.
    case GET_FARE_TYPE_RULES_REQUEST:
      return {
        ...initialState,
        loading: true,
      }
    // @ts-expect-error: Flow to TS migration.
    case GET_FARE_TYPE_RULES_SUCCESS:
      return {
        ...state,
        // @ts-expect-error: Flow to TS migration.
        rules: action.res.rules,
        // @ts-expect-error: Flow to TS migration.
        ticket: action.res.ticket,
        success: true,
        loading: false,
      }
    // @ts-expect-error: Flow to TS migration.
    case GET_FARE_TYPE_RULES_FAILURE:
      return {
        ...state,
        error: true,
        loading: false,
      }
    default:
      return state
  }
}

// SELECTORS
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fareTypeSelector = (state: any): FareTypeTicket => state.fareType.ticket
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fareTypeRulesSelector = (state: any): FareTypeRules => state.fareType.rules

// ACTIONS
export const getFareTypeAction = (bid: BookingId) => {
  return {
    type: GET_FARE_TYPE_RULES,
    promise: fetchFareTypeRules(bid),
    _track: {},
  }
}
